"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "plant-nursery-table table-items-list customers-table"
  }, [_c("b-table", {
    attrs: {
      data: _vm.tableData,
      loading: _vm.isLoading,
      striped: true,
      hoverable: true,
      "mobile-cards": true
    },
    on: {
      "update:loading": function updateLoading($event) {
        _vm.isLoading = $event;
      }
    }
  }, [_c("b-table-column", {
    attrs: {
      field: "name",
      label: "Cliente",
      sortable: ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.name || "--") + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "cpfCnpj",
      label: "CPF/CNPJ",
      sortable: ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(props.row.cpfCnpj || "--") + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "createdAt",
      label: "Criado em",
      sortable: ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n      " + _vm._s(_vm.formatDate(props.row.createdAt)) + "\n    ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      label: "Ações",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("b-dropdown", {
          attrs: {
            position: "is-bottom-left"
          }
        }, [_c("b-button", {
          staticClass: "is-text",
          attrs: {
            slot: "trigger",
            "icon-right": "dots-vertical"
          },
          slot: "trigger"
        }), _vm._v(" "), _c("b-dropdown-item", {
          on: {
            click: function click($event) {
              return _vm.$emit("edit", props.row);
            }
          }
        }, [_vm._v("\n          Editar\n        ")]), _vm._v(" "), _c("b-dropdown-item", {
          on: {
            click: function click($event) {
              return _vm.$emit("delete", props.row);
            }
          }
        }, [_vm._v("\n          Remover\n        ")])], 1)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;